/**
 * Tailwind class strings the Assignment tab repeats across its molecules (buttons, labels,
 * cards). Colours come from the tab's design tokens (see assignment.component.css), so the
 * same classes work in light and dark mode.
 */

const focusRing = 'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-(--app-accent-ring)';

const btn = `inline-flex cursor-pointer items-center gap-[9px] whitespace-nowrap rounded-md font-(family-name:--font-display) font-bold leading-none tracking-[0.005em] transition-[background-color,transform,box-shadow,border-color] duration-[140ms] ease-[cubic-bezier(0.2,0,0,1)] disabled:cursor-not-allowed disabled:opacity-40 disabled:shadow-none ${focusRing}`;
const sm = 'px-3.5 py-[9px] text-sm';

export const ui = {
  focusRing,

  /** Inter 12px caption. */
  sub: 'font-(family-name:--font-fallback) text-xs font-medium leading-[1.45] text-(--fg-3)',
  /** Inter 11px uppercase label, without a colour (add one). */
  kickerBase: 'font-(family-name:--font-fallback) text-[11px] font-bold uppercase tracking-[0.09em]',
  /** Inter 11px uppercase label. */
  kicker: 'font-(family-name:--font-fallback) text-[11px] font-bold uppercase tracking-[0.09em] text-(--fg-3)',
  card: 'rounded-xl border border-(--border-subtle) bg-(--mba-surface) shadow-[0_2px_6px_rgba(18,6,43,0.08)]',
  sectionTitle: 'm-0 font-(family-name:--font-display) text-[22px] font-bold leading-none tracking-[-0.02em] text-(--fg-1)',

  btnPrimary: `${btn} ${sm} bg-(--app-accent) text-white shadow-[0_8px_22px_var(--app-accent-ring)] hover:bg-(--app-accent-strong) active:scale-[0.985]`,
  btnOutline: `${btn} ${sm} border-[1.5px] border-(--border-strong) bg-transparent text-(--fg-1) hover:border-(--fg-1)`,
  btnGhost: `${btn} ${sm} bg-transparent text-(--app-accent-strong) hover:bg-(--app-accent-soft)`,
  btnDanger: `${btn} ${sm} bg-(--danger) text-white hover:bg-(--danger-hover)`,
  /** Buttons on the deep-purple bulk bar. */
  btnOnDark: `${btn} ${sm} bg-white/12 text-white hover:bg-white/22`,

  iconButton: `grid size-[34px] shrink-0 cursor-pointer place-items-center rounded-[10px] text-(--fg-2) hover:bg-(--bg-alt) ${focusRing}`,

  /** Red text button (Withdraw invite, Un-hire). */
  textDanger: `inline-flex cursor-pointer items-center gap-1.5 self-start rounded-md text-[13px] font-bold text-(--danger) hover:underline ${focusRing}`,

  avatar: 'relative grid size-10 shrink-0 place-items-center rounded-full bg-(--app-accent-soft) font-(family-name:--font-display) text-base font-extrabold text-(--app-accent-strong)',
  avatarLink: `cursor-pointer transition-shadow duration-[140ms] hover:ring-[3px] hover:ring-(--app-accent-ring) ${focusRing}`,
  verifiedBadge: 'absolute -right-[3px] -bottom-[3px] box-content grid size-4 place-items-center rounded-full border-2 border-(--mba-surface) bg-(--app-accent) text-white',
  /** The platform's own icon, bare: no backing circle. */
  platformLogo: 'size-3.5 shrink-0 object-contain',

  newCreatorPill: 'inline-flex items-center gap-[5px] rounded-full bg-(--app-accent-soft) px-[9px] py-[3px] text-[11px] font-bold text-(--app-accent-strong)',
  dash: 'text-(--fg-muted)',

  skeleton: 'block h-3.5 animate-pulse rounded-md bg-(--bg-alt)',
} as const;
